import { gql } from '~gql-types/gql'

export const FETCH_USER_PROFILE = gql(`
  query FetchUserProfile($id: ID!) {
    user(id: $id) {
      id
      username
      firstname
      lastname
      avatar
      legacyEid
      profilePhotoUrl
      coverPhotoUrl
      description
      website
      followers {
        followersCount
      }
      followees {
        followeesCount
      }
      followsUser
    }
  }
`)

export const TOGGLE_FRIENDSHIP = gql(`
  mutation ToggleFriendship($userId: ID!) {
    toggleFriendship(userId: $userId) {
      id
      followers {
        followersCount
      }
      followees {
        followeesCount
      }
      followsUser
    }
  }
`)

export const FETCH_USER_FOLLOWERS = gql(`
  query FetchUserFollowers($id: ID!) {
    user(id: $id) {
      id
      followers {
        followers {
          ...UserFields
        }
        followersCount
      }
    }
  }
`)

export const FETCH_USER_FOLLOWEES = gql(`
  query FetchUserFollowees($id: ID!) {
    user(id: $id) {
      id
      followees {
        followees {
          ...UserFields
        }
        followeesCount
      }
    }
  }
`)

export const USERNAME_EXISTS = gql(`
  query UsernameExists($username: String!) {
    usernameAvailable(userName: $username)
  }
`)

export const FETCH_USER_NOTIFICATION_SETTINGS = gql(`
  query FetchUserNotificationSettings {
    loggedInUser {
      notificationSettings {
        id
        type
        channels
        board {
          id
          title
        }
      }
    }
  }
`)

export const UPDATE_NOTIFICATION_SETTING = gql(`
  mutation UpdateNotificationSetting($params: NotificationSettingParams!) {
    updateNotificationSetting(params: $params) {
      id
      notificationSettings {
        id
        type
        channels
        board {
          id
        }
      }
    }
  }
`)

export const CLEAR_BOARD_SETTINGS = gql(`
  mutation ClearBoardSpecificNotificationSettings {
    clearBoardSpecificNotificationSettings {
      id
      notificationSettings {
        id
        type
        channels
        board {
          id
        }
      }
    }
  }
`)

export const CLEAR_OVERRIDDEN_SETTING = gql(`
  mutation ClearOverriddenNotificationSetting($type: NotificationSettingType!) {
    clearOverriddenNotificationSetting(type: $type) {
      id
      notificationSettings {
        id
      }
    }
  }
`)

export const VIEWABLE_NETWORKS_QUERY = gql(`
  query ViewableNetworks {
    loggedInUser {
      id
      viewableNetworks {
        network {
          id
          name
          title
        }
        viewableParent {
          id
          name
          title
        }
      }
    }
  }
`)

export const FETCH_USER_PROFILE_SETTINGS = gql(`
  query FetchUserProfileSettings {
    loggedInUser {
      id
      username
      firstname
      lastname
      website
      description
      emails {
        id
        text
        verified
      }
      primaryEmail {
        id
        text
        verified
      }
    }
  }
`)

export const UPDATE_USER_PROFILE = gql(`
  mutation UpdateUserProfile($username: String!, $firstname: String, $lastname: String, $primaryEmailId: ID!, $website: String, $description: String) {
    updateProfile(username: $username, firstname: $firstname, lastname: $lastname, primaryEmailId: $primaryEmailId,, website: $website, description: $description) {
      id
      username
      firstname
      lastname
      website
      description
      primaryEmail {
        id
        text
        verified
      }
    }
  }
`)
